/**
 * 对客展示提示词时剥掉系统段(1006 演示机复测:对客页露出「【画幅构图】…」「★…」规则行、英文风格串)。
 *
 * 逐行过滤:丢【…】开头的系统段行、★ 规则行、禁用词清单行、纯英文长行(风格串)。只用于展示,
 * 不回写、不用于再提交。海报长图的「第 N 部分」结构另有 screenPromptView(更精细)。
 */
export function stripSystemPromptLines(raw: string | null | undefined): string {
  if (!raw) return "";
  return raw
    .split("\n")
    .filter((line) => {
      const t = line.trim();
      if (!t) return true;
      if (/^【[^】]{1,24}】/.test(t) || t.startsWith("★")) return false;
      if (/禁用词|禁止使用以下|不得出现以下词/.test(t)) return false;
      const cjk = (t.match(/[一-鿿]/g) ?? []).length;
      return !(t.length >= 24 && cjk / t.length < 0.1);
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
